import { Reveal, SectionLabel } from "./Reveal";

const STEPS = [
  ["Download aplikasi", "Install BagiPulsa dari Google Play dan buat akun kamu."],
  ["Pilih operator", "Pilih Telkomsel, XL, Axis, Three, Indosat, atau Smartfren, lalu masukkan nominal."],
  ["Kirim pulsa", "Transfer pulsa sesuai instruksi yang muncul di aplikasi."],
  ["Uang cair", "Uang masuk ke rekening bank atau eWallet kamu dalam 1–10 menit."],
];

export const Steps = () => (
  <section id="cara-kerja" data-testid="steps-section" className="mx-auto max-w-[1400px] px-5 py-24 md:px-10 md:py-36">
    <Reveal>
      <SectionLabel index="04">Cara kerja</SectionLabel>
      <h2 className="mt-6 font-display text-4xl font-bold leading-[1] tracking-tight text-paper md:text-6xl">Empat langkah, <span className="text-volt">cuan cair.</span></h2>
    </Reveal>
    <ol className="mt-16 grid grid-cols-1 gap-px overflow-hidden rounded-3xl bg-white/[0.08] sm:grid-cols-2 lg:grid-cols-4">
      {STEPS.map(([title, text], i) => (
        <li key={title} className="bg-ink">
          <Reveal delay={i * 0.1} className="group h-full p-8 transition-colors duration-500 hover:bg-surface md:p-10" data-testid={`step-${i + 1}`}>
            <span className="font-display text-7xl font-bold text-outline transition-colors duration-500 group-hover:text-volt">0{i + 1}</span>
            <h3 className="mt-10 font-display text-xl font-semibold text-paper">{title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-zinc-300 md:text-base">{text}</p>
          </Reveal>
        </li>
      ))}
    </ol>
  </section>
);
